import script from "./LabeledSelectWithCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabeledSelectWithCreate.vue?vue&type=script&setup=true&lang=ts"

import "./LabeledSelectWithCreate.vue?vue&type=style&index=0&id=eab32b74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eab32b74"]])

export default __exports__